// characters
import placeholderImage from "./characters/Placeholder h300.png";
import efelamonImage from "./characters/Efelamon h300.png";
import andrakasImage from "./characters/Andrakas h300.png";
import talisinImage from "./characters/Talisin h300.png";
import selenaImage from "./characters/Selena h300.png";
import undaaratelImage from "./characters/Undaaratel h300.png";
import taznarImage from "./characters/Taznar h300.png";

export const characterAssets = {
  _placeholder: {
    path: placeholderImage,
    alt: "The Last Spark by Eleonor Piteira @eleonorpiteira",
  },
  andrakas: {
    path: andrakasImage,
    alt: "D&D Halfling Fighter/Rogue/Bearstander by Brendon Chang @bchangart",
  },
  talisin: {
    path: talisinImage,
    alt: "Elf by BoissB",
  },
  efelamon: {
    path: efelamonImage,
    alt: "Tibalt, The Fiend Blooded by Peter Mohrbacher @petemohrbacher",
  },
  selena: {
    path: selenaImage,
    alt: "Enchantress by Lauren Walsh @laurenwalshart",
  },
  undaaratel: {
    path: undaaratelImage,
    alt: "Witch by @euna.draw",
  },
  taznar: {
    path: taznarImage,
    alt: "Kolyat Krios, Mass Effect",
  },
};
